import t from "./_getNative.js";
import r from "./_root.js";
var e = t, o = r, a = e(o, "Set"), m = a;
export {
  m as default
};
//# sourceMappingURL=_Set.js.map
